import { Controller } from "@hotwired/stimulus";

// data-controller="flash-notice"
export default class extends Controller {
  static targets = ["flash"];

  connect() {
    if (this.hasFlashTarget) {
      setTimeout(() => {
        this.flashClose();
      }, 4000);
    }
  }

  flashClose() {
    const flash = this.hasFlashTarget ? this.flashTarget : this.element;
    if (flash) {
      flash.style.opacity = '0';
      setTimeout(() => {
        flash.innerHTML = null;
      }, 1000);
    }
  }

  close(event) {
    event.preventDefault();
    this.flashClose();
  }
}
